import { useRouter } from 'next/router'
import { useQueryClient } from 'react-query'
import { useEffect } from 'react'

import { historyUtils } from '@wartek-id/toolbox-helper'
import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'

import {
  EmptyStateAction,
  EmptyStateImage,
  EmptyStateWithIllustration,
} from 'components/EmptyState'
import { USER_DETAIL_BASE_PATH } from 'app/PemetaanKompetensiPage/constants/competency'

function IneligiblePage() {
  const router = useRouter()

  const queryClient = useQueryClient()

  useEffect(() => {
    // Invalidate the cache of the eligibiilty check query upon unmount
    return () => {
      queryClient.resetQueries(`${USER_DETAIL_BASE_PATH}/profile/REFLEKSI`)
    }
  }, [queryClient])

  return (
    <>
      <HeaderBar>
        <HeaderBarLeftAction
          onClick={() => historyUtils?.backToApp(router?.back)}
        />
        <HeaderBarTitle>Refleksi Kompetensi</HeaderBarTitle>
      </HeaderBar>
      <EmptyStateWithIllustration
        title="Saat ini, halaman baru tersedia untuk Guru PNS. Mohon ditunggu."
        description="Halaman ini sedang kami persiapkan agar dapat segera hadir untuk Anda. Jika ada kendala, silakan kunjungi Pusat Bantuan."
      >
        <EmptyStateImage imageSrc="/images/errors/img-forbiden-access.png" />
        <EmptyStateAction
          color="black"
          onClick={() => {
            historyUtils?.backToApp(() => router.replace('/home'))
          }}
        >
          Kembali ke Beranda
        </EmptyStateAction>
        <EmptyStateAction
          color="white"
          href="https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/21276770843289"
        >
          Ke Pusat Bantuan
        </EmptyStateAction>
      </EmptyStateWithIllustration>
    </>
  )
}

IneligiblePage.layoutOpts = {
  className: 'text-default bg-gray-10',
}

export default IneligiblePage
